import { getSelectors } from '@repo/core'
import { RootState } from '../../store/types'

export const userInfoSelector = (state: RootState) => state.users.user.read.info.payload
export const userInfoFetchStateSelector = (state: RootState) =>
  state.users.user.read.info.meta.fetchState
export const userInfoIsLoadingSelector = (state: RootState) =>
  state.users.user.read.info.meta.fetchState === 'loading'
export const userInfoHasErrorSelector = (state: RootState) => state.users.user.read.info.error

export const editUserDataSelector = (state: RootState) => state.users.user.write.infoData

export const editUserInfoDataSelector = {
  ...getSelectors({
    getRootPath: (state: RootState) => state.users.user.write.info,
  }),
  isDoneSelector: (state: RootState) => state.users.user.read.info.meta.fetchState === 'done',
}
